module.exports = __webpack_public_path__ + "static/media/koha-spa.f5923263.jpg";